import * as moment from 'moment';
import * as React from 'react';
import {
  idCreateRegex,
  N_ORG_LIST_UPDATE,
  orgLabelRegex
} from '@config/index';
import {
  UserContextProps,
  OrgContext,
  OrgContextProps,
  OrgInfo,
  orgToLocal,
  AgentContextProps,
  AgentContext,
  AgentInfo,
  UserContext
} from '@interface/index';
import { API } from '@config/api';
import {
  NiButton,
  NiInput,
  Header,
  CommonBreadcrumbItem,
  NiSearchBar,
  NiForm
} from '@component/index';
import { CheckOutlined } from '@ant-design/icons';
import { message, Menu } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import 'moment/locale/zh-cn';
import '@style/org/add-org.less';
import { localizedString } from '@locale/index';
import { instance } from '@lib/index';

moment.locale('zh-cn');

const logo = require('@static/image/logo.png');

export type AddOrgPropsInfo = RouteComponentProps<any> & {
  $user: UserContextProps;
  $org: OrgContextProps;
  $agent: AgentContextProps;
};

export interface AddOrgStateInfo {
  orgName: string;
  orgList: any[];
  open: boolean;
  loading: boolean;
  loadingOrg: string;
  type: string;
  isFirstSearch: boolean;
  selected?: string;
  err?: string;
  searchClicked: boolean;
}

class AddOrg extends React.Component<AddOrgPropsInfo, AddOrgStateInfo> {
  constructor(props: AddOrgPropsInfo) {
    super(props);

    this.state = {
      orgName: '',
      orgList: [],
      open: false,
      loading: false,
      loadingOrg: '',
      type: 'create',
      isFirstSearch: false,
      searchClicked: false
    };
  }

  render() {
    const { match } = this.props;
    const {
      orgName,
      open,
      orgList,
      selected,
      err,
      searchClicked
    } = this.state;

    return (<div
      className="create-org"
    >
      <div className="body-wrapper">
        <NiForm direction="vertical"
          items={[{
            label: localizedString('org_label'),
            key: 'create',
            content: <NiInput
              placeholder={localizedString('org_label_placeholder')}
              value={orgName}
              onChange={(e: any) => {
                this.setState({
                  orgName: e.target.value,
                });
              }}
            />
          }]}
        />
        <div className="search-row">

          {/* <NiSearchBar
            placeholder={localizedString('org_name_placeholder')}
            value={orgName}
            onChange={(value: string) => {
              this.setState({
                selected: undefined,
                orgName: value,
                open: false,
                err: undefined,
                searchClicked: false
              });
            }}
            onSearch={() => {
              this.handleSearchOrg();
            }}
            extra={
              searchClicked && [
                <NiButton
                  style={{ marginLeft: 8 }}
                  type="primary"
                  key={selected ? 'join' : 'selected'}
                  onClick={() => {
                    if (!selected) {
                      this.handleCreateOrg();
                    } else {
                      this.handleJoinOrg();
                    }
                  }}
                >
                  {selected === undefined ? localizedString('common_create') : localizedString('common_join_in')}
                </NiButton>
              ]
            }
          /> */}
        </div>
        {open &&
          <Menu
            className="suggest-list"
            selectable={false}
            onClick={(param: any) => {
              if (param.key === selected) {
                this.setState({
                  selected: undefined,
                  searchClicked: false
                });
              } else {
                this.setState({
                  selected: param.key,
                  searchClicked: true
                });
              }
            }}
          >
            {orgList.map((item: any) =>
              <Menu.Item key={item.id}
                className="item-row"
              >
                <span
                >
                  {item.name}
                </span>
                {selected === item.id
                  ? <CheckOutlined />
                  : ''}
              </Menu.Item>)}
          </Menu>
        }
        {err &&
          <span style={{ color: 'red' }}>{err}</span>
        }
      </div>
    </div>
    );
  }

  handleCreateOrg = () => {
    const { orgList, orgName } = this.state;
    const { history, $org } = this.props;
    if (orgList.findIndex((item: any) => item.name === orgName) !== -1) {
      message.warning(localizedString('org_name_repeated'));
      return;
    }

    const ncs = orgName.split('.');
    if (ncs.length > 2) {
      message.warning(localizedString('common_invalid_name'));
      throw new Error(localizedString('common_invalid_name'));
    }

    for (const c of ncs) {
      if (!orgLabelRegex.test(c)) {
        message.warning(localizedString('common_invalid_name'));
        throw new Error(localizedString('common_invalid_name'));
      }
    }

    if (window.localStorage.getItem('dev') !== 'true') {
      if (!orgName.startsWith('me.') &&
        !orgName.startsWith('io.')) {
        message.warning(localizedString('org_name_prefix_hint'));
        throw new Error(localizedString('org_name_prefix_hint'));
      }
    }

    const props = {
      org_name: orgName
    };

    API.org
      .create(props)
      .then(orgToLocal)
      .then((res: OrgInfo) => {
        message.success(localizedString('common_create_success'));
        instance.emit(N_ORG_LIST_UPDATE);
        history.push(`/org/${res.name}/agent`);
      })
      .catch((err: any) => {
        message.error(err.message);
        this.setState({ err: err.message });
      });
  };

  handleSearchOrg = () => {
    const { orgName } = this.state;

    if (!orgName) {
      return;
    }
    API.org
      .search(orgName)
      .then((res: any) => {
        this.setState({
          orgList: res,
          open: true
        });
      })
      .catch((err: any) => {
        this.setState({ searchClicked: true });
        throw new Error(err.message);
      });
  };

  handleJoinOrg = () => {
    const { history } = this.props;
    const { orgName, selected } = this.state;

    API.org
      .join({
        org_id: selected
      })
      .then((res: any) => {
        message.success(localizedString('org_applying_for', { org: orgName }));
        instance.emit(N_ORG_LIST_UPDATE);
      })
      .catch((err: any) => {
        message.error(err.message);
        this.setState({ err: err.message });
      });
  };
}

export default (props: any) => (
  <UserContext.Consumer>
    {($user: UserContextProps) => (
      <OrgContext.Consumer>
        {($org: OrgContextProps) =>
          <AgentContext.Consumer>
            {($agent: AgentContextProps) => (
              <AddOrg {...props} $user={$user} $org={$org} $agent={$agent} />
            )}
          </AgentContext.Consumer>
        }
      </OrgContext.Consumer>
    )}
  </UserContext.Consumer>
);
